/**
 * Accordion / Collapsible tab toggle.
 * Works with .accordion__button and .accordion__content pairs.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var button = e.target.closest('.accordion__button');
    if (!button) return;

    var content = button.nextElementSibling;
    if (!content || !content.classList.contains('accordion__content')) return;

    var isOpen = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', !isOpen);
    content.setAttribute('data-open', !isOpen);

    if (!isOpen) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0px';
    }
  });
})();
